// extracted by mini-css-extract-plugin
module.exports = {"confusedBanner":"_3g53k","confusedBannerText":"_1zM4Z","arrow":"_2HtLB","phoneImg":"_1my0R","modalWrapper":"_3PP6T","videoStepsWrapper":"_33wcg","ctaWrapper":"_3O7oC"};